import React from 'react';

export class Polyline extends React.Component {
  componentWillUpdate() {
    this.line.setMap(null);
  }

  componentWillUnmount() {
    this.line.setMap(null);
  }

  render() {
    const GooglePolyline = this.props.maps.Polyline;

    const renderedPolyline = this.renderPolyline();
    const paths = {path: this.props.path};

    this.line = new GooglePolyline(Object.assign({}, renderedPolyline, paths));

    this.line.setMap(this.props.map);

    return null;
  }

  renderPolyline() {
    throw new Error('Implement renderPolyline method');
  }
}


export default class Normal extends Polyline {
  renderPolyline() {
    return {
      geodesic: true,
      strokeColor: this.props.color || '#ffffff',
      strokeOpacity: 1,
      strokeWeight: 4,
    };
  }
}



// WEBPACK FOOTER //
// ./src/components/LoadMap/Polyline.js